import React from "react";
import styled, { css } from "styled-components";
import { Spinner, Icon } from "components/common";
const SuccessIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.variant.success};
  `
);
const ErrorIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.variant.danger};
  `
);
const ProgressMessage = ({
  stepName = void 0,
  isLoading,
  isSuccess,
  isError,
  name = void 0,
  errorMessage = void 0,
  title = void 0,
  details = void 0
}) => {
  const loadingText = {
    createStream: (entityName) => `Creating Stream${entityName !== void 0 ? ` "${entityName}"` : ""}...`,
    startStream: (entityName) => `Starting Stream${entityName !== void 0 ? ` "${entityName}"` : ""}...`,
    createPipeline: (entityName) => `Creating Pipeline${entityName !== void 0 ? ` "${entityName}"` : ""}...`,
    setupRouting: (_) => "Setting up routing...",
    result: (_) => "",
    deleteStream: (entityName) => `Deleting Stream${entityName !== void 0 ? ` "${entityName}"` : ""}...`,
    deletePipeline: (entityName) => `Deleting Pipeline${entityName !== void 0 ? ` "${entityName}"` : ""}...`,
    deleteRouting: (_) => "Removing routing...",
    connectPipeline: (_) => "Connecting pipeline to stream..."
  };
  const errorText = {
    createStream: (entityName) => `Creating Stream${entityName !== void 0 ? ` "${entityName}"` : ""} failed!`,
    startStream: (entityName) => `Starting Stream${entityName !== void 0 ? ` "${entityName}"` : ""} failed!`,
    createPipeline: (entityName) => `Creating Pipeline${entityName !== void 0 ? ` "${entityName}"` : ""} failed!`,
    setupRouting: (_) => "Setting up routing failed!",
    result: (_) => "Starting the Input has failed. Please roll it back to clean it up.",
    deleteStream: (entityName) => `Deleting Stream${entityName !== void 0 ? ` "${entityName}"` : ""} failed!`,
    deletePipeline: (entityName) => `Deleting Pipeline${entityName !== void 0 ? ` "${entityName}"` : ""} failed!`,
    deleteRouting: (_) => "Removing routing failed!",
    connectPipeline: (_) => "Connecting pipeline to stream failed!"
  };
  const successText = {
    createStream: (entityName) => `Stream${entityName !== void 0 ? ` "${entityName}"` : ""} created!`,
    startStream: (entityName) => `Stream${entityName !== void 0 ? ` "${entityName}"` : ""} started!`,
    createPipeline: (entityName) => `Pipeline${entityName !== void 0 ? ` "${entityName}"` : ""} created!`,
    setupRouting: (_) => "Routing set up!",
    result: (_) => "Input started successfully!",
    deleteStream: (entityName) => `Stream${entityName !== void 0 ? ` "${entityName}"` : ""} deleted!`,
    deletePipeline: (entityName) => `Pipeline${entityName !== void 0 ? ` "${entityName}"` : ""} deleted!`,
    deleteRouting: (_) => "Routing removed!",
    connectPipeline: (_) => "Pipeline connected to stream successfully!"
  };
  if (isLoading) {
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Spinner, { text: title != null ? title : loadingText[stepName](name) }));
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(ErrorIcon, { name: "close", title: title != null ? title : errorText[stepName](name) }), title != null ? title : errorText[stepName](name)), details || errorMessage && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, "Details:"), " ", details != null ? details : errorMessage.message));
  }
  if (isSuccess) {
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(SuccessIcon, { name: "check", title: title != null ? title : successText[stepName](name) }), title != null ? title : successText[stepName](name));
  }
  return null;
};
export default ProgressMessage;
